var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 546,
    viewBox: "0 0 473 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 62.5,
    y1: 2.18557e-8,
    x2: 62.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 146.5,
    y1: 2.18557e-8,
    x2: 146.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 2.18557e-8,
    x2: 231.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 2.18557e-8,
    x2: 312.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 404.5,
    y1: 2.18557e-8,
    x2: 404.5,
    y2: 546,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 102.5,
    x2: -40,
    y2: 102.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 186.5,
    x2: -40,
    y2: 186.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 271.5,
    x2: -40,
    y2: 271.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 352.5,
    x2: -40,
    y2: 352.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 506,
    y1: 444.5,
    x2: -40,
    y2: 444.5,
    stroke: "white",
    strokeOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a0da48aaa42ec5ea23a163bd5f4ae232.svg";
export { ForwardRef as ReactComponent };